import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';
import { TOOTH_TYPE_CODES } from '@/shared/config';

export const getNegativeToothTypeConditionIDs = (
  toothConditions: Condition[],
  conditionCode: ConditionCode,
): string[] => [
  ...new Set(
    toothConditions
      .filter(
        (condition) =>
          TOOTH_TYPE_CODES.includes(condition.Code) &&
          condition.Code !== conditionCode,
      )
      .map((condition) => condition.ID),
  ),
];
